export enum ContractProcessState {
  AwaitingApproval,
  AwaitingUpload,
  Approved,
  NotStarted,
  PreContractSigned
}
